import { Stack, useBreakpointValue, FormControl, FormLabel, HStack, IconButton, Text, Button } from '@chakra-ui/react'
import * as React from 'react'
import { IBaseDrawerProps } from '../BaseDrawer';
import { Field, FieldProps, FormikProps } from 'formik';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';
import { InputFormControl } from '../../formcontrols/InputFormControl';
import { IApiProjectOptionObserver } from '../../../models/api/project/options/IApiProjectOptionObserver';
import { ContactSearch } from '../../ContactSearch/ContactSearch';
import { ContactSearchResult } from '../../ContactSearch/ContactSearchResult';
import { FiEdit2, FiPlus } from 'react-icons/fi';
import { useContext, useState } from 'react';
import { ApiContext } from '../../../contexts/ApiProvider';
import { AddContactDrawer } from '../contact/AddContactDrawer';
import Helpers from '../../../Helpers';
import toast from 'react-hot-toast';
import { Autocomplete } from '../../Autocomplete/Autocomplete';
import { IApiContactResponse } from '../../../models/api/contact/IApiContactResponse';
import { AutocompleteContactResult } from '../../Autocomplete/AutocompleteContactResult';
import { AutocompleteContactHit } from '../../Autocomplete/AutocompleteContactHit';

export interface IAddObserverDrawerProps extends Omit<IBaseDrawerProps<IApiProjectOptionObserver>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText"> {
    defaultValue?: IApiProjectOptionObserver;
    exclusions: string[];
}

export const AddObserverDrawer = (props: IAddObserverDrawerProps) => {
    const [addContact, setAddContact] = useState(false);
    const { postContact } = useContext(ApiContext);
    return (
        <BaseDrawerWithForm
            isOpen={props.isOpen}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue ?? {
                active: true,
                role: "",
                contact: undefined
            }}
            headerText="Beobachter hinzufügen"
            validateOnBlur={false}
        >
            {({ handleSubmit, errors, touched, isSubmitting, setFieldValue }: FormikProps<IApiProjectOptionObserver>) => (
                <Stack px="0" spacing="4">
                    <FormControl>
                        <FormLabel htmlFor="contact">
                            <HStack>
                                <Text>Kontakt</Text>
                                <Button leftIcon={<FiPlus />} variant={'outline'} size={'xs'} onClick={() => setAddContact(true)}>erstellen</Button>
                            </HStack>
                        </FormLabel>
                        <Field name="contact" validate={(value: any) => (value === undefined) ? "Kontakt ist erforderlich!" : undefined}>
                            {({ meta: { value } }: FieldProps) => (
                                <>
                                    {(!value && (
                                        /* <ContactSearch onSelect={(c) => setFieldValue("contact", c, true)} exclusions={props.exclusions} maxHeight={"sm"} /> */
                                        <Autocomplete<IApiContactResponse> 
                                            sourceId='contacts' 
                                            indexName='dev_contacts' 
                                            itemTemplate={props => (<AutocompleteContactHit {...props} onClick={() => setFieldValue("contact", props.item, true)} />)} />
                                    )) || (
                                        <HStack justifyContent="space-between">
                                            <AutocompleteContactResult contact={value} />
                                            <IconButton aria-label="bearbeiten" icon={<FiEdit2 />} variant="ghost" onClick={() => setFieldValue("contact", undefined, true)} />
                                        </HStack>
                                    )}
                                </>
                            )}
                        </Field>                   
                    </FormControl>
                    <InputFormControl 
                        field="role"
                        label="Rolle (optional)"
                        isInvalid={(errors.role && touched.role) ? true : false}
                        isDisabled={isSubmitting}
                        errorMessage={errors.role}
                    />
                    <AddContactDrawer 
                        isOpen={addContact} 
                        onDiscard={() => setAddContact(false)}
                        onSubmit={(data) => {
                            var promise = postContact(data);
                            toast.promise(promise, {
                                loading: `Kontakt wird erstellt...`,
                                success: (result) => {
                                    setFieldValue("contact", data, true);
                                    setAddContact(false);
                                    return `Der Kontakt wurde erfolgreich erstellt!`;
                                },
                                error: (code) => Helpers.buildToastErrorMessage(code, `Fehler beim Erstellen des Kontakts!`)
                            });
                            return promise;
                        }}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}